import { useEffect, useState } from "react"
import { draftAPI } from "../../../../../../utilities/api";
import { useAppDispatch, useAppSelector } from "../../../../../../app/hooks";
import { getFilingSupportingDocs } from "../../../../../../features/state/StateFiling-slice";
import { APISettings } from "../../../../../../config/ApiSettings";
import saveAs from "file-saver";

export const useDocketDetailsController = (
  drafts: any,
  filingId: any
) => {

  //#region draft preview
  const filingHearingDocs = useAppSelector((state) => state.filings.filingHearingDocs);
  const filingFiscalDocs = useAppSelector((state) => state.filings.filingFiscalDocs);
  const filingExplanatoryDocs = useAppSelector((state) => state.filings.filingExplanatoryDocs);

  const dispatch = useAppDispatch();

  const [draftPreviewOpen, setDraftPreviewOpen] = useState<boolean>(false);

  const [draftHtml, setDraftHtml] = useState<string>();

  const toggleDraftPreview = async (draftId?: number) => {
    if (!draftPreviewOpen && draftId) {
      setDraftHtml(await draftAPI.getPreview(draftId));
    }

    if (draftPreviewOpen) {
      setDraftHtml(undefined);
    }

    setDraftPreviewOpen(!draftPreviewOpen);
  }

  const [draftDropdownItems, setDraftDropdownItems] = useState<any>([]);

  useEffect(() => {
    if (!!drafts && drafts.length > 0 && draftDropdownItems.length < 1) {
      let newDropdownItems = [];
      for (let draft of drafts) {
        newDropdownItems.push({
          id: draft.id,
          displayName: !!draft.chapter.chapterName && !!draft.chapter.chapterNumber ?
            `${draft.chapter.chapterNumber}: ${draft.chapter.chapterName}` :
            !!draft.chapter.chapterName ?
              draft.chapter.chapterName : draft.chapter.chapterNumber ?? '',
        })
      }
      setDraftDropdownItems(newDropdownItems);
    }
    dispatch(getFilingSupportingDocs(filingId));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //#endregion

  const baseUrl = new APISettings().getApiURL();

  const downloadPdf = async (containerName: string, blobName: string) => {
    let url = `${baseUrl}/fileStorage/GetAsByteArray/${containerName}/${blobName}`;
    let blob: Blob = await fetch(url).then((r) => r.blob());

    saveAs(blob, blobName);
  }

  const parseUTCDate = (date: any) => {
    return new Date(date[date.length - 1] === 'Z' ? date : date.concat('Z')).toLocaleString();
  }

  const emailLiaison = (contactInfo: string) => {
      window.open("mailto:" + contactInfo);
  };

  return {
    //redux
    filingHearingDocs,
    filingFiscalDocs,
    filingExplanatoryDocs,
    //values
    draftPreviewOpen,
    draftHtml,
    draftDropdownItems,
    //functions
    toggleDraftPreview,
    downloadPdf,
    parseUTCDate,
    emailLiaison
  }
}